import { userMenu } from './userMenu.js';

var notifications = {
  options: {
    ajax_url: sikmoVars.ajax_url,
    doing_ajax: false,
  },

  selectors: {
    el_notifications: ".js-notifications",
    el_notifications_button: ".js-notifications-button",
    el_notifications_counter: ".js-notifications-count",
    el_notifications_list: ".js-notifications-modal-list",
    el_notifications_button_set_all_as_read: ".js-notifications-modal-set-all-as-read",
  },

  init: function (settings) {
    const self = this;

    //Checks
    if (jQuery(self.selectors.el_notifications).length === 0) {
      return;
    }

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //clicks events
    self.clickEventToggleNotifications();
    self.clickEventSetNotificationAsRead();
    self.clickEventSetAllNotificationsAsRead();

    self.getNotifications(); //init get all notifications

    //every 10sec check (delay 200ms)
    setTimeout(() => {
      setInterval(function () {
        self.checkForNewNotifications();
      }, 10000);
    }, 200);
  },

  clickEventToggleNotifications: function () {
    const self = this;

    jQuery(self.selectors.el_notifications_button).on("click", function (event) {
      event.preventDefault();
      jQuery(self.selectors.el_notifications).toggleClass("header__notifications--open");
      userMenu.closeMenu();
    });
  },

  closeNotifications: function () {
    const self = this;
    jQuery(self.selectors.el_notifications).removeClass("header__notifications--open");
  },

  clickEventSetNotificationAsRead: function () {
    const self = this;

    jQuery(self.selectors.el_notifications_list).find("a").on("click", function (event) {
      event.preventDefault();
      let that = this;

      jQuery.ajax({
        dataType: "json",
        url: self.options.ajax_url,
        data: {
          action: "notifications",
          notifications_action: "set_as_read",
          id_notification: jQuery(this).data("id"),
        },
        timeout: 500, //if limit is exceeded its not big deal
      }).always(function () {
        //redirect
        window.location.href = that.href;
      });
    });
  },

  clickEventSetAllNotificationsAsRead: function () {
    const self = this;

    jQuery(self.selectors.el_notifications_button_set_all_as_read).on("click", function (event) {
      event.preventDefault();
      let that = this;

      jQuery.ajax({
        dataType: "json",
        url: self.options.ajax_url,
        data: {
          action: "notifications",
          notifications_action: "set_all_as_read",
        },
      }).done(function (data) {
        //reload
        self.getNotifications();
      });
    });
  },

  checkForNewNotifications: function () {
    const self = this;

    if (theme.globals.isDevelopment) console.log("Checking for new notifications.");

    if (!self.options.doing_ajax) {
      self.options.doing_ajax = true;

      jQuery.ajax({
        dataType: "json",
        url: self.options.ajax_url,
        data: {
          action: "notifications",
          notifications_action: "check_for_new"
        },
      })
        .done(function (data) {
          if (data.new_notification) {
            if (theme.globals.isDevelopment) console.log("Got new notification!");
            self.reloadAllFromData(data.data);
          }
        })
        .always(function () {
          self.options.doing_ajax = false;
        });
    }
  },

  getNotifications: function () {
    const self = this;

    if (!self.options.doing_ajax) {
      self.options.doing_ajax = true;

      jQuery.ajax({
        dataType: "json",
        url: self.options.ajax_url,
        data: {
          action: "notifications",
          notifications_action: "get_all"
        },
      })
        .done(function (data) {
          if (data.new_notification) {
            self.reloadAllFromData(data.data);
          }
        })
        .always(function () {
          self.options.doing_ajax = false;
        });
    }
  },

  reloadAllFromData: function (data) {
    const self = this;

    let html = "";
    let count_unread = 0;

    html += '<ul>';
    data.forEach((row) => {
      html += '<li' + (!row[2] ? ' class="unread"' : '') + '><a href="' + row[0] + '" data-id="' + row[3] + '"><img src="' + row[4] + '"><span class="right"><span>' + row[1] + '</span><span>' + row[5] + '</span></span></a></li>';
      if (!row[2]) count_unread++;
    });
    html += '</ul>';

    jQuery(self.selectors.el_notifications_counter).text(count_unread);
    if (count_unread === 0) {
      jQuery(self.selectors.el_notifications_counter).addClass("hide");
    } else {
      jQuery(self.selectors.el_notifications_counter).removeClass("hide");
    }

    jQuery(self.selectors.el_notifications_list).html(html);

    //reassign click event
    self.clickEventSetNotificationAsRead();
  },
}

// Exporting the jQuery plugin/module
export { notifications };